// Nota: las categorías reales (id/nombre/slug) vienen del backend vía
// CategoriaService (GET /public/categories) — nunca hardcodearlas aquí, ya
// que un listado desincronizado hace que los filtros por categoría apunten
// al idCategoria equivocado (bug real detectado: este archivo tenía un
// catálogo de 16 categorías con nombres/ids que no correspondían a los
// reales del backend).

export interface PaisCatalogo {
  code: string;
  nombre: string;
  dial: string;
  slug: string;
  flag: string;
}

export const PAISES: PaisCatalogo[] = [
  { code: 'MX', nombre: 'México', dial: '+52', slug: 'mexico', flag: '🇲🇽' },
  { code: 'CO', nombre: 'Colombia', dial: '+57', slug: 'colombia', flag: '🇨🇴' },
  { code: 'EC', nombre: 'Ecuador', dial: '+593', slug: 'ecuador', flag: '🇪🇨' },
  { code: 'CR', nombre: 'Costa Rica', dial: '+506', slug: 'costa-rica', flag: '🇨🇷' },
  { code: 'PE', nombre: 'Perú', dial: '+51', slug: 'peru', flag: '🇵🇪' },
  { code: 'AR', nombre: 'Argentina', dial: '+54', slug: 'argentina', flag: '🇦🇷' },
  { code: 'CL', nombre: 'Chile', dial: '+56', slug: 'chile', flag: '🇨🇱' },
  { code: 'PA', nombre: 'Panamá', dial: '+507', slug: 'panama', flag: '🇵🇦' },
  { code: 'UY', nombre: 'Uruguay', dial: '+598', slug: 'uruguay', flag: '🇺🇾' },
  { code: 'DO', nombre: 'República Dominicana', dial: '+1', slug: 'republica-dominicana', flag: '🇩🇴' },
  { code: 'GT', nombre: 'Guatemala', dial: '+502', slug: 'guatemala', flag: '🇬🇹' },
];

/**
 * Detecta el país del usuario a partir del locale del navegador
 * (`navigator.language`, ej. "es-MX" -> región "MX") y lo resuelve contra
 * PAISES. Si la región detectada no está en el catálogo soportado (o no hay
 * `navigator` disponible, ej. SSR), regresa México como fallback.
 */
export function detectDefaultPais(paises: PaisCatalogo[]): PaisCatalogo | undefined {
  const region =
    typeof navigator !== 'undefined'
      ? navigator.language?.split(/[-_]/)[1]?.toUpperCase()
      : undefined;
  return paises.find((p) => p.code === region) ?? paises[0];
}

export function banderaIso(code: string): string {
  const normalized = code.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return '';
  return String.fromCodePoint(...[...normalized].map((char) => 127397 + char.charCodeAt(0)));
}
